'use client';

import { Box } from '@terra/ui-styled-system';
import { LabelDefault, MonoSmall } from '../../components/typography';
import { MarkdownPreview } from '../markdown-preview';
import { hasMarkdownCodeFence } from './evidence-artifact-content';

type EvidenceArtifactContentSectionProps = {
  label: string;
  content: string;
};

export function EvidenceArtifactContentSection({
  label,
  content,
}: EvidenceArtifactContentSectionProps) {
  return (
    <Box px={3} py={2}>
      <LabelDefault as="span" display="block" color="fg.muted" mb={1}>
        {label}
      </LabelDefault>
      {hasMarkdownCodeFence(content) ? (
        <Box bg="bg.muted" borderRadius="sm" px={2} py={1} overflowX="auto">
          <MarkdownPreview
            source={content}
            fontSize={12}
            compact
            escapeRawHtml
          />
        </Box>
      ) : (
        <MonoSmall
          as="div"
          display="block"
          bg="bg.muted"
          borderRadius="sm"
          p={2}
          whiteSpace="pre-wrap"
          overflowX="auto"
        >
          {content}
        </MonoSmall>
      )}
    </Box>
  );
}
